// root '../../../';

// dependencies
import { Child } from 'pym.js';
import { select } from 'd3-selection';
import debounce from 'lodash/fp/debounce';
import accessibleAutocomplete from 'accessible-autocomplete';
import * as d3 from 'd3';
import Zion from './utils/Zion';


// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils & graphic
import config from './config';
import graphic from './graphic';

// styles
import './styles/index.scss';

/* develblock:start */
import meta from './data/meta.json';

const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  // console.clear();
}


let hasInit;
let jsonData;
let selectedPlaces = new Set([]);
// const endpoint = 'https://ix.cnn.io/data/hoam/metros_latest_test.json';
const endpoint = 'https://ix.cnn.io/data/housing-affordability/cbsa_housing_affordability_index_recent.json';

// Function to convert date string "YYYY-MM-DD" to "Month, YYYY" format
const formatDate = (dateString) => {
  const date = new Date(`${dateString}T00:00:00Z`); // Use UTC to avoid timezone issues
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
  ];
  const month = months[date.getUTCMonth()];
  const year = date.getUTCFullYear();
  return `${month}`;
};

const init = async (graphicConfig, container, isMobile) => {
  if (!hasInit) {
    hasInit = true;
    const response = await fetch(endpoint);
    jsonData = await response.json();

    // Format the latest_date and combine with lastUpdatedStr
    const formattedDate = formatDate(jsonData.latest_date);
    select('#timestamp').text(`Data current through ${formattedDate} as of ${jsonData.lastUpdatedStr}.`);

    graphic(graphicConfig, container, isMobile, jsonData, 'last_score', selectedPlaces);


    const btns = [...document.querySelectorAll('.map-button-group .button')];
    btns.forEach((btn) => {
      btn.addEventListener('click', () => {
        btns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const clz = btn.getAttribute('data-prop') === 'last_score' ? 'current' : 'historic';
        btn.classList.add(clz);
        graphic(null, null, null, jsonData, btn.getAttribute('data-prop'), selectedPlaces);
      });
    });


    // const btns = [...document.querySelectorAll('.switch li')];
    // btns.forEach((btn) => {
    //   btn.addEventListener('click', () => {
    //     btns.forEach(b => b.classList.remove('selected'));
    //     btn.classList.add('selected');
    //     graphic(null, null, null, jsonData, btn.getAttribute('data-prop'), selectedPlaces);
    //   });
    // });


    // search setup
    const places = [...new Set(jsonData.data.metros.map(d => d.name))];

    accessibleAutocomplete({
      element: document.querySelector('#metro-autocomplete-container'),
      id: 'metro-autocomplete', // To match it to the existing <label>.
      placeholder: 'Search for a metro area...',
      displayMenu: 'overlay',
      source: places,
      onConfirm: (val) => {
        if (!val) return;
        // const places = metros.filter(d => d.name === val);
        // searchBox.property('value', place);
        selectedPlaces = new Set([val]);
        // searchResults.html('');
        graphic(null, null, null, jsonData, null, selectedPlaces);
      },
    });

    const searchBox = d3.select('#searchBox');
    const clearButton = d3.select('#clearButton');
    clearButton.on('click', () => {
      searchBox.property('value', '');

      document.getElementById('metro-autocomplete').value = '';
      selectedPlaces = new Set([]);
      graphic(null, null, null, jsonData, null, selectedPlaces);
      // filterAndDraw(processedData);
    });
  } else if (jsonData) {
    graphic(graphicConfig, container, isMobile, jsonData);
  }
};


const draw = async (initialWidth) => {
  const container = select('#graphic');

  const fallbackWidth = container.node().clientWidth || 600;
  const safeWidth = initialWidth !== fallbackWidth ? fallbackWidth : initialWidth;
  const isMobile = safeWidth <= 500;

  const heightMultiplier = isMobile ? 1 : 9 / 16;
  const initialHeight = heightMultiplier * safeWidth;

  const props = { initialWidth: safeWidth, initialHeight, isMobile };

  const graphicConfig = config(props);
  // graphic(graphicConfig, container, isMobile);
  // hasInit = true;
  init(graphicConfig, container, isMobile);
};


const debouncedDraw = debounce(100)(draw);

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: debouncedDraw, id: pkg.name });

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};
